import { RootState } from "@/store/store";
import { taskManagementSliceSelector } from "@/store/task-management/selectors/taskManagementSliceSelector";

export const taskViewDetailsSelector = (state: RootState) => {
  return taskManagementSliceSelector(state)?.views?.details;
};
